










































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { Teacher } from '../../../src_server/entity/generated/Teacher';
import { InputPages } from '../../components/organisms/InputPages';
// import { MessageDialog } from '../../utils/MessageDialog';
// import { FileUpload } from '../../biz/FileUpload';
import historykana from 'historykana';
import { prefecturesOptions } from '../../../src_server/entity/master/prefecturesData';
import { ZipCodeService } from '../../biz/remote/ZipCodeService';
import { MessageDialog } from '../../utils/MessageDialog';
import FileInput from './FileInput.vue';
import { TeacherFileDTO } from '../../../src_server/entity/dto/TeacherFileDTO';
import ErrorSummary from '../../components/inputs/ErrorSummary.vue';
import { Session } from '../../utils/Session';
@Component({
  components: { FileInput, ErrorSummary },
})
export default class TeacherInfoPage extends InputPages {
  @Prop()
  private value!: Teacher;

  @Prop({ default: () => new TeacherFileDTO() })
  private file!: TeacherFileDTO;

  get model() {
    return this.value;
  }

  set model(value) {
    this.value = value;
  }

  get isCO() {
    return Session.isCircleOBuilding();
  }

  onUploadFile(value: any) {
    console.log('onUploadFile tip', value);
    this.file = value;
    this.$emit('file-upload', value);
  }

  private keyHistory: string[] = [];
  inputName(e: Event) {
    const key = (e.target as HTMLInputElement).value;
    if (key === '') {
      this.keyHistory = [];
    }
    this.keyHistory.push(key);
    this.model.full_name_kana = historykana(this.keyHistory);
  }

  get prefectures() {
    return prefecturesOptions;
  }

  async zip() {
    console.log('zip', this.model.zip_code);
    const res = await new ZipCodeService().zipCode(this.model.zip_code || '');
    const results = res.data.results;
    if (results && results[0]) {
      const result = results[0];
      await MessageDialog.alert(`${this.model.zip_code}に対応する住所${result.address1}${result.address2}${result.address3}をセットしました`);
      this.model.prefecture = result.address1; // 都道府県
      this.model.city_name = result.address2; // 市区町村
      this.model.address_line1 = result.address3; // 町域
    }
  }

  validate() {
    // const valid = super.validate();
    const fileIn = this.$refs['file_input'] as FileInput;
    return fileIn.validate();
  }
}
